<template>
  <Consent />
</template>

<script>
import Consent from '@/components/templates/Consent.vue'
const contentURL = process.env.VUE_APP_SCONTENT_URL || 'https://scontent.finnomena.com'

export default {
  components: {
    Consent
  }
  
}
</script>
